<template>
  <div class="approvals content-wrapper content-wrapper--align-start">
    <template v-if="isFetching">
      <h1 v-if="typeFilter == 'Review'">Reviews</h1>
      <h1 v-if="typeFilter == 'SEO'">SEO Articles</h1>
      <div class="table-options">
        <div class="placeholder-search"></div>
      </div>
      <div class="placeholder-table">
        <div class="placeholder-table__header"></div>
      </div>
    </template>
    <template v-else>
      <h1 v-if="typeFilter == 'Review'">Reviews</h1>
      <h1 v-if="typeFilter == 'SEO'">SEO Articles</h1>
      <div class="table-options">
        <span>Filters:</span>
        <div class="select-container select-container--no-label">
          <select v-model="statusFilter" data-cy="status-filter">
            <option value="">All Statuses</option>
            <option default value="Pending Review">Pending Review</option>
            <option value="Revision Needed">Revision Needed</option>
            <option value="Approved">Approved</option>
            <option value="Exported">Exported</option>
            <option value="Live">Live (discontinued)</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="marketFilter" data-cy="language-filter">
            <option value="">All Markets</option>
            <option v-for="market in oldMarketList" v-bind:key="market.id" :value="market.id">{{ market.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="siteFilter" data-cy="site-filter">
            <option value="">All Sites</option>
            <option v-for="site in siteList" v-bind:key="site.id" :value="site.id">{{ site.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">  <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="monthFilter">
            <option value="-1">All Months</option>
            <option v-for="month in monthList" v-bind:key="month.id" :value="month.id">{{ month.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="freelancerFilter">
            <option value="">All Freelancers</option>
            <option v-for="freelancer in freelancers" v-bind:key="freelancer.id" :value="freelancer.id">{{ freelancer.content.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="search-container">
          <!-- prettier-ignore -->
          <svg data-v-8cd888b6 xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"> <path fill="#bcbccb" data-v-8cd888b6 d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
          <input class="input input--search-icon" v-model="searchFilter" placeholder="Search brand, keyword, title or user" />
        </div>
      </div>
      <div class="table">
        <div class="table__headers">
          <div @click="sortKey = 'site'" class="table__header">Site</div>
          <div @click="sortKey = 'type'" class="table__header">Type</div>
          <div @click="sortKey = 'brand'" class="table__header">Brand/Keyword</div>
          <div @click="sortKey = 'market'" class="table__header">Language/Country</div>
          <div @click="sortKey = 'title'" class="table__header">Title</div>
          <div @click="sortKey = 'submittedAt'" class="table__header">Submit Date</div>
          <div @click="sortKey = 'user'" class="table__header">User</div>
          <div @click="sortKey = 'status'" class="table__header">Status</div>
          <div class="table__header"></div>
        </div>
        <template v-for="(content, index) in filteredContentList">
          <router-link v-bind:key="content.id" :to="'/approvals/' + $route.params.type + '/' + content.id" class="table__row" :data-cy="`content-${index}`">
            <div class="table__cell">{{ content.siteId }}</div>
            <div class="table__cell">{{ content.type }}</div>
            <div class="table__cell">{{ content.keyword }}</div>
            <div class="table__cell">{{ content.languageId }}</div>
            <div class="table__cell">{{ content.title }}</div>
            <div class="table__cell">{{ submitDateFormatted(content.submittedAt) }}</div>
            <div class="table__cell">{{ content.submittedBy.content.name }}</div>
            <div class="table__cell">{{ content.status }}</div>
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </router-link>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mapGetters } from 'vuex'

export default {
  name: 'approvals',
  data() {
    return {
      contentList: [],
      isFetching: true,
      searchFilter: '',
      typeFilter: '',
      statusFilter: 'Pending Review',
      marketFilter: '',
      siteFilter: '',
      monthFilter: -1,
      freelancerFilter: '',
      sortKey: 'submittedAt',
    }
  },
  methods: {
    getContentList() {
      var _this = this
      firebase
        .firestore()
        .collection('users')
        .get()
        .then(function(querySnapshot) {
          let userList = []
          querySnapshot.forEach(function(doc) {
            userList.push({ id: doc.id, content: doc.data() })
          })
          firebase
            .firestore()
            .collection('content')
            .get()
            .then(function(querySnapshot) {
              let data = []
              querySnapshot.forEach(function(doc) {
                var submittedBy = {}
                var reviewedBy = {}
                for (let i = 0; i < userList.length; i++) {
                  if (userList[i].id == doc.data().adminData.submittedBy) {
                    submittedBy = userList[i]
                  }
                  if (userList[i].id == doc.data().adminData.reviewedBy) {
                    reviewedBy = userList[i]
                  }
                }
                let title = doc.data().userData.title
                let keyword = doc.data().userData.keyword
                if (doc.data().userData.type === 'Review') {
                  title = doc.data().userData.brand.name + ' Review'
                  keyword = doc.data().userData.brand.name
                }
                data.push({
                  id: doc.id,
                  status: doc.data().adminData.status,
                  type: doc.data().userData.type,
                  title: title,
                  keyword: keyword,
                  brand: doc.data().userData.brand.name,
                  siteId: doc.data().userData.site.id,
                  languageId: doc.data().userData.language.id,
                  submittedAt: doc.data().adminData.submittedAt,
                  submittedBy,
                  reviewedBy,
                })
              })
              _this.isFetching = false
              _this.contentList = data
            })
            .catch(function(error) {
              console.error('Error getting documents: ', error)
              _this.$notify({
                text: 'Failed to get content list',
                type: 'error',
              })
            })
        })
        .catch(function(error) {
          console.error('Error getting users documents: ', error)
        })
    },
    submitDateFormatted(submitDate) {
      let date = new Date(submitDate)
      return date.toLocaleString('da-DK')
    },
    characterCount(string) {
      return string.length
    },
    updateContentType() {
      if (this.$route.params.type == 'review') {
        this.typeFilter = 'Review'
      } else if (this.$route.params.type == 'seo') {
        this.typeFilter = 'SEO'
      }
    },
  },
  mounted: function() {
    this.getContentList()
    this.updateContentType()
  },
  computed: {
    ...mapGetters(['user', 'freelancers', 'oldMarketList', 'siteList', 'monthList']),
    filteredContentList() {
      let contentMatch = this.contentList.filter(content => {
        return (
          (content.brand.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
            content.keyword.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
            content.submittedBy.content.name.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
            content.title.toLowerCase().includes(this.searchFilter.toLowerCase())) &&
          (this.typeFilter == '' || content.type == this.typeFilter) &&
          (this.statusFilter == '' || content.status == this.statusFilter) &&
          (this.marketFilter == '' || content.languageId == this.marketFilter) &&
          (this.siteFilter == '' || content.siteId == this.siteFilter) &&
          (this.monthFilter == -1 || new Date(content.submittedAt).getMonth() == this.monthFilter) &&
          (this.freelancerFilter == '' || content.submittedBy.id == this.freelancerFilter)
        )
      })

      if (this.sortKey === 'site') {
        contentMatch.sort((a, b) => (a.siteId > b.siteId ? 1 : -1))
      } else if (this.sortKey === 'type') {
        contentMatch.sort((a, b) => (a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1))
      } else if (this.sortKey === 'brand') {
        if (this.typeFilter == 'Review') {
          contentMatch.sort((a, b) => (a.brand.toLowerCase() > b.brand.toLowerCase() ? 1 : -1))
        } else {
          contentMatch.sort((a, b) => (a.keyword.toLowerCase() > b.keyword.toLowerCase() ? 1 : -1))
        }
      } else if (this.sortKey === 'language') {
        contentMatch.sort((a, b) => (a.languageId.toLowerCase() > b.languageId.toLowerCase() ? 1 : -1))
      } else if (this.sortKey === 'title') {
        contentMatch.sort((a, b) => (a.title > b.title ? 1 : -1))
      } else if (this.sortKey === 'submittedAt') {
        contentMatch.sort((a, b) => (a.submittedAt < b.submittedAt ? 1 : -1))
      } else if (this.sortKey === 'user') {
        contentMatch.sort((a, b) => (a.content.submittedBy.content.name < b.content.submittedBy.content.name ? 1 : -1))
      } else if (this.sortKey === 'status') {
        contentMatch.sort((a, b) => (a.status < b.status ? 1 : -1))
      }

      return contentMatch
    },
  },
  watch: {
    '$route.params.type': function() {
      this.updateContentType()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/textarea.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/table.scss';

.user {
  max-width: 100%;
  .content {
    pre {
      overflow: auto;
    }
  }
}
.content-wrapper--align-start {
  grid-template-rows: auto;
  align-content: start;
}
.copyscape,
.wordcount {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  text-decoration: none;
  color: #43425d;
}
.wordcount {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  span {
    font-size: 0.875rem;
  }
}
.copyscape > svg {
  margin-right: 0.25rem;
}
.copyscape-link-icon {
  transform: rotate(-90deg);
}
a.copyscape:hover {
  color: var(--color-cta);
}
.copyscape:hover .copyscape-link-icon > path {
  fill: var(--color-cta);
}
.placeholder-search {
  margin-left: auto;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  width: 240px;
  height: 33px;
}
.table-options {
  display: flex;
  align-items: center;
}
.search-container {
  width: 240px;
  margin-left: auto;
  position: relative;
}
.search-container > svg {
  position: absolute;
  transform: translateY(-50%);
  top: 45%;
  left: 0.5rem;
}
.button-container {
  display: flex;
  margin-left: auto;
}
.table-options .select-container {
  margin-left: 1rem;
}
.seo-container,
.content-container,
.pros-cons-container,
.faq-container,
.pros-cons-shortcode-container,
.how-to-container {
  position: relative;
  display: grid;
  gap: 1rem 1.5rem;
  padding-bottom: 1.5rem;
  h3 {
    font-size: 1rem;
    grid-column: 1 / -1;
    font-weight: 400;
    margin: 0;
  }
  &:before {
    content: '';
    position: absolute;
    top: calc(100%);
    width: 100%;
    height: 1px;
    background: #ebebf2;
  }
}
.seo-container {
  grid-template-columns: auto 1fr;
}
.pros-cons-container {
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}
.question,
.pros,
.cons,
.step {
  position: relative;
  display: grid;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background-color: #ebebf0;
  border-radius: 0.25rem;
  .input,
  textarea {
    background: white;
  }
  .input-container {
    display: grid;
    grid-template-columns: 60px 1fr;
    align-items: center;
    gap: 1rem;
  }
  span {
    font-size: 0.8125rem;
  }
}
</style>
